import { type FC } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { Body2, Checkbox } from '@sbol/nova';
import type { AnswersViewProps } from '../AnswersView';
import { SingleSelect_styles } from '../SingleSelect';
import type { MultiSelectModel } from './MultiSelectModel';
import styles from './MultiSelect.module.scss';

export const MultiSelect: FC<AnswersViewProps<MultiSelectModel>> = observer(({ questionModel }) => {
  const { question, handleClickOption } = questionModel;

  return (
    <ul className={SingleSelect_styles.SingleSelect}>
      {question.form_answers.map((answer) => {
        const disabled = questionModel.isAnswerDisabled(answer);

        return (
          <li
            key={answer.id}
            className={clsx(SingleSelect_styles.Option, disabled && SingleSelect_styles.disabled)}
            onClick={!disabled ? () => handleClickOption(answer.id) : undefined}
          >
            <Checkbox
              value={answer.id}
              checked={questionModel.isAnswerSelected(answer)}
              disabled={disabled}
              className={styles.Checkbox}
              onChange={() => {}} // Чтобы реакт не ругался
            />
            <Body2 className={SingleSelect_styles.Option_text}>{answer.answer_text}</Body2>
          </li>
        );
      })}
    </ul>
  );
});
